import Background from './Background';

function Profile() {
    return <Background />;
}

export default Profile;
